const breakpoints = {
  m: '@media (min-width: 768px)',
  l: '@media (min-width: 1205px)',
};

export default breakpoints;
